import { useTracking } from 'react-tracking';

import { Grid, Text, useTheme } from '@simplywallst/ui-core';
import { Narrative } from '@/pages/PublicNarrativeAuthoring/hooks/useNarrativeById';
import { NarrativeDisclaimerBadge } from '../NarrativeDisclaimerBadge';

import { useAuthorProfileImage } from '../../hooks';
import { AuthorImage, StyledLink } from './styled';

type Props = {
  announcementCount: number;
  author: Narrative['author'];
  userHoldsPosition: boolean | null;
};

export const NarrativeAuthor = ({
  announcementCount,
  author,
  userHoldsPosition,
}: Props) => {
  const theme = useTheme();
  const { trackEvent } = useTracking();

  const { displayName, name, role, url, imageUrl } = author;

  const authorImageUrl = useAuthorProfileImage({
    src: imageUrl,
    width: 32,
    height: 32,
  });

  const isUserGeneratedNarrative =
    url === null && imageUrl === null && displayName;

  if (isUserGeneratedNarrative) {
    return (
      <Grid
        gap="8px"
        templateColumns="32px max-content max-content"
        alignItems="center"
      >
        <Grid
          alignContent="center"
          justifyContent="center"
          height={theme.x4}
          width={theme.x4}
          borderRadius="x4"
          backgroundColor="darkGray"
          boxShadow="strongBorder"
        >
          <Text typography="small" textAlign="center" color="textSolid">
            {displayName.substring(0, 2).toUpperCase()}
          </Text>
        </Grid>
        <Text typography="small" color="textSolid">
          {displayName}
        </Text>
        <NarrativeDisclaimerBadge userHoldsPosition={userHoldsPosition} />
      </Grid>
    );
  }

  return (
    <Grid
      gap="8px"
      templateColumns="32px max-content max-content max-content"
      alignItems="center"
    >
      <AuthorImage src={authorImageUrl} alt="narrative-author-image" />
      <StyledLink
        href={url ? url : ''}
        target="_blank"
        rel="noreferrer"
        onClick={() =>
          trackEvent({
            modifier: 'author',
            action: 'click',
            announcementCount,
          })
        }
      >
        <Text
          typography="small"
          color="textSolid"
          data-cy-id="narrative-author-name"
        >
          {name}
        </Text>
      </StyledLink>
      {role !== '' && (
        <Text
          typography="tiny"
          color="mediumGray"
          data-cy-id="narrative-author-role"
        >
          {role}
        </Text>
      )}
      {name !== 'Warren' && (
        <NarrativeDisclaimerBadge userHoldsPosition={userHoldsPosition} />
      )}
    </Grid>
  );
};
